// util.ts
function uint8ArrayToBase64(uint8Array) {
  const chars = [...uint8Array].map((b) => String.fromCharCode(b));
  return btoa(chars.join(""));
}
export {
  uint8ArrayToBase64
};
